import { PageTitle } from "@/components/page-title";
import { InvoiceUploadForm } from "./_upload_form";

function InvoiceUploadNew() {
  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <PageTitle>Upload invoices</PageTitle>
      <InvoiceUploadForm />
    </div>
  );
}

export default InvoiceUploadNew;
